<template>
  <b-modal :visible="show" :hide-header="true" centered id="modal-dever-informar" size="md"
    :hide-footer="true">
    <div class="float-right"><img @click="hide" class="close-modal" src="img/x-modal.svg" /></div>
    <div class="text-justify mt-3">
      <h5 class="bold-modal">Por que suas informações precisam estar corretas</h5>
      <!--
        Texto legal SUSEP — vem de config.js (fonte única do app).
        Ver specs/001-avisos-legais-susep. NÃO reescrever a redação aqui.
      -->
      <div class="mb-2">{{ config.TEXTO_LEGAL_DEVER_INFORMAR }}</div>
      <div class="center-modal mt-5">
        <button type="button" class="continue-btn-modal" @click="hide"> Entendi </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import config from "../../config";

export default {
  props: ["show"],
  data() {
    return { config };
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
<style>
#modal-dever-informar___BV_modal_content_ {
  border-radius: 12px !important;
  padding: 25px;
  padding-top: 15px;
  color: #78849E;
}
</style>
